export default {"src":"/_next/static/media/light_bg_logo.d0a58c71.svg","height":35,"width":200,"blurWidth":0,"blurHeight":0};